export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '战略牵引额度回馈配置';